import { LsAdapterNames, LsSchemaType, LsTopics } from '@easy-lib/modules/shared/models/ls.model';
import { LsSchemas } from '@easy-lib/modules/shared/models/lsSchemas';

export class LsConstants {
	static readonly LsSchemas: { type: LsSchemaType; schema: any }[] = [
		{
			type: LsSchemaType.BestLimit,
			schema: LsSchemas.MarketDepthBestPriceSchema
		},
		{
			type: LsSchemaType.ActiveStock,
			schema: LsSchemas.ActiveStockSchema
		},
		{ type: LsSchemaType.TradeVolume, schema: LsSchemas.TradeVolumeSchema },
		{
			type: LsSchemaType.EasyFilterIndInst,
			schema: LsSchemas.EasyFilterIndInstSchema
		},
		{
			type: LsSchemaType.GroupStateChange,
			schema: LsSchemas.GroupStateChangeSchema
		},
		{ type: LsSchemaType.TextMessage, schema: LsSchemas.TextMessageSchema },
		{ type: LsSchemaType.Order, schema: LsSchemas.orderStateNewSchema },
		{ type: LsSchemaType.OrderPlace, schema: LsSchemas.orderPlaceSchema },
		{ type: LsSchemaType.Money, schema: LsSchemas.MoneySchema },
		{ type: LsSchemaType.Symbol, schema: LsSchemas.SymbolSchema },
		{ type: LsSchemaType.DMarketWatch, schema: LsSchemas.MarketWatchSchema },
		{ type: LsSchemaType.SymbolHeader, schema: LsSchemas.SymbolHeaderSchema },
		{
			type: LsSchemaType.OrderFormAskOrBid,
			schema: LsSchemas.OrderFormAskOrBidSchema
		},
		{
			type: LsSchemaType.MarketDepthSymbol,
			schema: LsSchemas.MarketDepthSymbolSchema
		},
		{ type: LsSchemaType.StockInfo, schema: LsSchemas.StockInfoSchema },
		{ type: LsSchemaType.OrderForm, schema: LsSchemas.OrderFormSchema },
		{ type: LsSchemaType.EasyFilter, schema: LsSchemas.EasyFilterSchema },
		{ type: LsSchemaType.Search, schema: LsSchemas.SearchSchema },
		{ type: LsSchemaType.RecentSearch, schema: LsSchemas.RecentSearchSchema },
		{ type: LsSchemaType.MarketWatch, schema: LsSchemas.MobileWatchSchema },
		{ type: LsSchemaType.Portfolio, schema: LsSchemas.MobilePortfolioSchema },
		{
			type: LsSchemaType.RealtimePortfolio,
			schema: LsSchemas.MobileRealTimePortfolioSchema
		},
		{ type: LsSchemaType.Conditional, schema: LsSchemas.ConditionalSchema },
		{
			type: LsSchemaType.MarketAffecting,
			schema: LsSchemas.MarketAffectingSchema
		},
		{ type: LsSchemaType.BestOfMarket, schema: LsSchemas.BestOfMarketSchema },
		{ type: LsSchemaType.DPortfolio, schema: LsSchemas.DPortfolioSchema },
		{
			type: LsSchemaType.DRealtimePortfolio,
			schema: LsSchemas.DRealtimePortfolioSchema
		},
		{ type: LsSchemaType.TodayActivity, schema: LsSchemas.TodayActivity },
		{ type: LsSchemaType.Index, schema: LsSchemas.IndexSchema },
		{ type: LsSchemaType.MarketSheet, schema: LsSchemas.MarketSheetSchema },
		{
			type: LsSchemaType.MarketSheetChartBuy,
			schema: LsSchemas.MarketSheetBuyChartSchema
		},
		{
			type: LsSchemaType.MarketSheetChartSell,
			schema: LsSchemas.MarketSheetSellChartSchema
		},
		{
			type: LsSchemaType.MarketViewTopRank,
			schema: LsSchemas.MarketViewTopRankSchema
		},
		{
			type: LsSchemaType.SameGroup,
			schema: LsSchemas.SameGroupSchema
		},
		{
			type: LsSchemaType.Performance,
			schema: LsSchemas.PerformanceSchema
		},
		{
			type: LsSchemaType.PerformanceDetail,
			schema: LsSchemas.PerformanceDetailSchema
		},
		{
			type: LsSchemaType.AlgoParent,
			schema: LsSchemas.AlgoParentSchema
		},
		{
			type: LsSchemaType.PerformanceRecalculate,
			schema: LsSchemas.PerformanceRecalculateSchema
		},
		{
			type: LsSchemaType.MtsCommand,
			schema: LsSchemas.MtsCommandSchema
		},
		{
			type: LsSchemaType.OptionMarketView,
			schema: LsSchemas.OptionMarketViewSchema
		},
		{
			type: LsSchemaType.BlackScholesCalculator,
			schema: LsSchemas.BlackScholesCalculatorSchema
		},
		{
			type: LsSchemaType.OptionPosition,
			schema: LsSchemas.OptionPositionSchema
		},
		{
			type: LsSchemaType.ContractInfo,
			schema: LsSchemas.ContractInfoSchema
		},
		{
			type: LsSchemaType.OptionContract,
			schema: LsSchemas.OptionContractSchema
		},
		{
			type: LsSchemaType.OptionBaseSymbolInfo,
			schema: LsSchemas.ContractInfoSchema
		},
		{
			type: LsSchemaType.OptionCustomerStatus,
			schema: LsSchemas.OptionCustomerStatusSchema
		}
	];

	static readonly LsSchemasTopic: { schema: LsSchemaType; topic: string }[] = [
		{ schema: LsSchemaType.BestLimit, topic: LsTopics.BestLimit },
		{ schema: LsSchemaType.ActiveStock, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.TradeVolume, topic: LsTopics.TradeVolume },
		{ schema: LsSchemaType.EasyFilterIndInst, topic: LsTopics.TradeVolume },
		{ schema: LsSchemaType.GroupStateChange, topic: LsTopics.GroupStateChange },
		{ schema: LsSchemaType.TextMessage, topic: LsTopics.TextMessage },
		{ schema: LsSchemaType.Order, topic: LsTopics.Order },
		{ schema: LsSchemaType.OrderPlace, topic: LsTopics.OrderPlace },
		{ schema: LsSchemaType.Money, topic: LsTopics.Money },
		{ schema: LsSchemaType.DMarketWatch, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Symbol, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.SymbolHeader, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.MarketDepthSymbol, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.StockInfo, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.OrderForm, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.EasyFilter, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Search, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.RecentSearch, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.MarketWatch, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Portfolio, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.RealtimePortfolio, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Conditional, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.MarketAffecting, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.BestOfMarket, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.ReturnChart, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.DPortfolio, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.DRealtimePortfolio, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.OrderFormAskOrBid, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.TodayActivity, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.SameGroup, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Index, topic: LsTopics.Index },
		{ schema: LsSchemaType.MarketSheet, topic: LsTopics.MarketSheet },
		{
			schema: LsSchemaType.MarketSheetChartBuy,
			topic: LsTopics.MarketSheetChartBuy
		},
		{
			schema: LsSchemaType.MarketSheetChartSell,
			topic: LsTopics.MarketSheetChartSell
		},
		{ schema: LsSchemaType.MarketViewTopRank, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.Performance, topic: LsTopics.Performance },
		{ schema: LsSchemaType.PerformanceDetail, topic: LsTopics.PerformanceDetail },
		{ schema: LsSchemaType.AlgoParent, topic: LsTopics.AlgoParent },
		{ schema: LsSchemaType.PerformanceRecalculate, topic: LsTopics.PerformanceRecalculate },
		{ schema: LsSchemaType.MtsCommand, topic: LsTopics.MtsCommand },
		{ schema: LsSchemaType.OptionMarketView, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.BlackScholesCalculator, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.OptionPosition, topic: LsTopics.OptionPosition },
		{ schema: LsSchemaType.ContractInfo, topic: LsTopics.Symbol },
		{ schema: LsSchemaType.OptionContract, topic: LsTopics.OptionContract },
		{ schema: LsSchemaType.OptionCustomerStatus, topic: LsTopics.OptionCustomerStatus },
		{ schema: LsSchemaType.OptionBaseSymbolInfo, topic: LsTopics.Symbol }
	];

	static readonly LsAdapterName = [
		{ topic: LsTopics.BestLimit, value: LsAdapterNames.BestLimitAdapter },
		{ topic: LsTopics.Symbol, value: LsAdapterNames.RlcAdapter },
		{ topic: LsTopics.TradeVolume, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.GroupStateChange, value: LsAdapterNames.RlcAdapter },
		{ topic: LsTopics.TextMessage, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.Money, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.Order, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.Performance, value: LsAdapterNames.ThirdPartyAdapter },
		{ topic: LsTopics.PerformanceDetail, value: LsAdapterNames.ThirdPartyAdapter },
		{ topic: LsTopics.AlgoParent, value: LsAdapterNames.ThirdPartyAdapter },
		{ topic: LsTopics.OrderPlace, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.Index, value: LsAdapterNames.SleAdapter },
		{ topic: LsTopics.MarketSheet, value: LsAdapterNames.MarketSheetAdapter },
		{
			topic: LsTopics.MarketSheetChartBuy,
			value: LsAdapterNames.MarketSheetAdapter
		},
		{
			topic: LsTopics.MarketSheetChartSell,
			value: LsAdapterNames.MarketSheetAdapter
		},
		{
			topic: LsTopics.PerformanceRecalculate,
			value: LsAdapterNames.ThirdPartyAdapter
		},
		{
			topic: LsTopics.MtsCommand,
			value: LsAdapterNames.ThirdPartyAdapter
		},
		{
			topic: LsTopics.OptionPosition,
			value: LsAdapterNames.SleAdapter
		},
		{
			topic: LsTopics.OptionContract,
			value: LsAdapterNames.SleAdapter
		},
		{
			topic: LsTopics.OptionCustomerStatus,
			value: LsAdapterNames.SleAdapter
		}
	];

	static readonly SnapshotSchemas = [
		LsSchemaType.BestLimit,
		LsSchemaType.TradeVolume,
		LsSchemaType.GroupStateChange,
		LsSchemaType.Symbol,
		LsSchemaType.SymbolHeader,
		LsSchemaType.MarketDepthSymbol,
		LsSchemaType.StockInfo,
		LsSchemaType.OrderForm,
		LsSchemaType.EasyFilter,
		LsSchemaType.EasyFilterIndInst,
		LsSchemaType.Search,
		LsSchemaType.RecentSearch,
		LsSchemaType.Conditional,
		LsSchemaType.MarketAffecting,
		LsSchemaType.BestOfMarket,
		LsSchemaType.ReturnChart,
		LsSchemaType.TodayActivity,
		LsSchemaType.Index,
		LsSchemaType.MarketWatch,
		LsSchemaType.DMarketWatch,
		LsSchemaType.Portfolio,
		LsSchemaType.RealtimePortfolio,
		LsSchemaType.DPortfolio,
		LsSchemaType.DRealtimePortfolio,
		LsSchemaType.OrderFormAskOrBid,
		LsSchemaType.MarketViewTopRank,
		LsSchemaType.ActiveStock,
		LsSchemaType.SameGroup,
		LsSchemaType.OptionMarketView,
		LsSchemaType.BlackScholesCalculator,
		LsSchemaType.ContractInfo,
		LsSchemaType.OptionContract,
		LsSchemaType.OptionBaseSymbolInfo
	];

	static readonly RawModeSchemas: LsSchemaType[] = [
		LsSchemaType.Order,
		LsSchemaType.MarketSheetChartBuy,
		LsSchemaType.MarketSheetChartSell,
		LsSchemaType.Performance,
		LsSchemaType.PerformanceDetail,
		LsSchemaType.AlgoParent,
		LsSchemaType.OptionPosition,
		LsSchemaType.OptionCustomerStatus
	];

	static readonly FullModeChangeSchemas = [
		LsSchemaType.MarketWatch,
		LsSchemaType.DMarketWatch,
		LsSchemaType.Portfolio,
		LsSchemaType.RealtimePortfolio,
		LsSchemaType.DPortfolio,
		LsSchemaType.MarketViewTopRank,
		LsSchemaType.DRealtimePortfolio,
		LsSchemaType.SymbolHeader,
		LsSchemaType.ActiveStock,
		LsSchemaType.MarketDepthSymbol,
		LsSchemaType.TradeVolume,
		LsSchemaType.MarketSheet,
		LsSchemaType.BestLimit,
		LsSchemaType.OrderForm,
		LsSchemaType.SameGroup,
		LsSchemaType.OptionMarketView,
		LsSchemaType.ContractInfo,
		LsSchemaType.OptionContract,
		LsSchemaType.OptionBaseSymbolInfo
	];
}
